import * as jweixin from 'weixin-js-sdk'
import { userApi } from '@/api/index.js'
export default {
    //判断是否在微信中    
    isWechat: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/micromessenger/i) == 'micromessenger') {
            console.log('是微信客户端')
            return true;
        } else {
            console.log('不是微信客户端')
            return false;
        }
    },
    initJssdk: function (callback) {
        // var uri = encodeURIComponent(window.location.href);
        var uri = (window.location.href.split('#')[0]);//获取当前url然后传递给后台获取授权和签名信息  

        userApi.getSignConfig({
            appId: "wx5c9c265e473a0aef",
            url: uri,
        }).then((res) => {
            console.log(res)
            jweixin.config({
                debug: false,
                appId: res.appId,
                timestamp: res.timestamp,
                nonceStr: res.nonceStr,
                signature: res.signature,
                jsApiList: ['hideOptionMenu']
            });
            if (callback) {
                callback(res);

            }
        })

    },


    hideMenu: function (callback) {//选择图片  
        if (this.isWechat()) {
            this.initJssdk(function (res) {
                jweixin.ready(function () {
                    jweixin.hideOptionMenu()
                });
            });
        }

    },

}  
